// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2HMB2","footer":"ModalUpdate_footer__OizWx"};